<template>
  <div :class="keyboardClass" @mousedown="(e) => {e.preventDefault()}"></div>
</template>

<script>
  import Keyboard from "simple-keyboard";
  import "simple-keyboard/build/css/index.css";

  export default {
    name: "SimpleKeyboard",
    props: {
      keyboardClass: {
        default: "simple-keyboard",
        type: String
      },
      input: {
        type: String
      }
    },
    data: () => ({
      keyboard: null,
      layout: {
        type: Object,
        default: function() {
          return {
            default: [
              "` 1 2 3 4 5 6 7 8 9 0 - = {bksp}",
              "{tab} q w e r t y u i o p [ ]",
              "{lock} a s d f g h j k l ; ' {enter}",
              "{shift} z x c v b n m , . / {shift}",
              "@ {space}",
            ],
            shift: [
              "~ ! @ # $ % ^ &amp; * ( ) _ + {bksp}",
              "{tab} Q W E R T Y U I O P { } |",
              '{lock} A S D F G H J K L : " {enter}',
              "{shift} Z X C V B N M &lt; &gt; ? {shift}",
              "@ {space}",
            ],
          };
        },
      }
    }),
    mounted() {
      this.keyboard = new Keyboard(this.keyboardClass, {
        onChange: this.onChange,
        onKeyPress: this.onKeyPress
      });
      console.log(this.keyboard,'aaa')
      this.keyboard.setOptions({
        display: {
          "{enter}": "确定",
          "{shift}": "shift",
          "{bksp}": "删除",
          "{tab}": "tab",
          "{space}": "space",
          "{lock}": "caps",
        }
      })
    },
    methods: {
      onChange(input) {
        this.$emit("onChange", input);
      },
      onKeyPress(button) {
        this.$emit("onKeyPress", button);
        console.log('打印看卡',button)
        let value = ''
        if (button[0] == '{' && button[button.length - 1] == '}') {
          value = button.substring(1, button.length - 1)
        } else {
          value = button
        }

        if (button == '{shift}') {
          value = 'Shift'
        }
        if (button == '{bksp}') {
          value = 'Back'
        }
        if (button == '{space}') {
          value = 'Space'
        }
        if (button == '{tab}') {
          value = 'Tab'
        }
        if (button == '\\') {
          value = `\\`
        }
        if (button == '{lock}') {
         this.handleShift()
        }

        this.$api.onKeyborad({value})
      },

      handleShift() {
        let currentLayout = this.keyboard.options.layoutName;
        let shiftToggle = currentLayout === "default" ? "shift" : "default";

        this.keyboard.setOptions({
          layoutName: shiftToggle,
        });
      },

    },
    watch: {
      input(input) {
        this.keyboard.setInput(input);

      }
    }
  };
</script>

<style>
  .simple-keyboard {
    z-index: 99999 !important;
    position: fixed;
    left: 0;
    bottom: 0;
    padding: 20px 100px;
  }

  .hg-theme-default .hg-button {
    height: 60px;
    font-size: 18px;
  }

  /*.hg-theme-default .hg-button.hg-standardBtn{*/
  /*  height: 50px;*/
  /*  margin: 8px 10px;*/
  /*  font-size: 23px;*/
  /*  background-color: #fff;*/
  /*  border-radius: 8px;*/
  /*  cursor: pointer;*/
  /*  -webkit-box-shadow: 0 4px 0 #b2b2b2, 0 5px 10px rgba(0,0,0,.7);*/
  /*  box-shadow: 0 3px 0 #b2b2b2, 0 4px 6px rgba(0,0,0,.7);*/
  /*}*/

  /*.hg-theme-default .hg-button.hg-standardBtn:active {*/
  /*  box-shadow: 0 4px 0 #717070, 0 5px 3px rgba(0,0,0,.9);*/
  /*  background-color: #efefef;*/
  /*}*/


  /*.simple-keyboard.hg-layout-default .hg-button.bksp {*/
  /*  height: 50px;*/
  /*  margin: 8px 10px;*/
  /*  font-size: 23px;*/
  /*  background-color: #fff;*/
  /*  border-radius: 8px;*/
  /*  cursor: pointer;*/
  /*  -webkit-box-shadow: 0 4px 0 #b2b2b2, 0 5px 10px rgba(0,0,0,.7);*/
  /*  box-shadow: 0 3px 0 #b2b2b2, 0 4px 6px rgba(0,0,0,.7);*/
  /*  background: #a8001e;*/
  /*  color: white;*/
  /*}*/

  /*.simple-keyboard.hg-layout-default .hg-button.bksp:active {*/
  /*  box-shadow: 0 4px 0 #717070, 0 5px 3px rgba(0,0,0,.9);*/
  /*  background-color: #efefef;*/
  /*  color: #000000;*/
  /*}*/

  /*.simple-keyboard.hg-layout-default .hg-button.enter {*/
  /*  height: 50px;*/
  /*  margin: 8px 10px;*/
  /*  font-size: 23px;*/
  /*  background-color: #fff;*/
  /*  border-radius: 8px;*/
  /*  cursor: pointer;*/
  /*  -webkit-box-shadow: 0 4px 0 #b2b2b2, 0 5px 10px rgba(0,0,0,.7);*/
  /*  box-shadow: 0 3px 0 #b2b2b2, 0 4px 6px rgba(0,0,0,.7);*/
  /*  background: #a8001e;*/
  /*  color: white;*/
  /*}*/

  /*.simple-keyboard.hg-layout-default .hg-button.enter:active {*/
  /*  box-shadow: 0 4px 0 #717070, 0 5px 3px rgba(0,0,0,.9);*/
  /*  background-color: #efefef;*/
  /*  color: #000000;*/
  /*}*/
</style>
